module.exports = "<lightbulb-icon animate\r\n                class=\"lightbulb\"></lightbulb-icon>"